export default "<hr class=\"dropdown-menu-hr\"/>\n"